export default __webpack_public_path__ + "static/media/9.2114a5d0.jpg";